import React, { useEffect, useState } from 'react';
import Badge from '../../uiKit/badge';
import ButtonOutlined from '../../uiKit/buttons/outlined';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default React.memo(function GameCard({ game, callback, isOpen ,className='' }) {
  const { t } = useTranslation('common');
  const [showInfo, setShowInfo] = useState(isOpen);
  const navigate = useNavigate();

  useEffect(() => {
    setShowInfo(isOpen);
  }, [isOpen]);

  const openCard = () => {
    setShowInfo(true);
    callback && callback(game.id);
  };

  const goToGamePage = () => {
    navigate(`/games/${game.slug}`);
  };

  return (
    <div onClick={openCard}
         className={`relative flex w-full h-full rounded-2xl overflow-hidden select-none transition-all group ${!isOpen ? 'cursor-pointer' : 'md:-translate-y'} ${className}`}>
      <div className={'flex items-center justify-center w-full h-full'}>
        <img src={game.iconPreview} alt={`${game.name} icon`} className={'w-full h-full object-cover'} draggable={false}/>
      </div>

      <div
        className={`absolute hover:translate-all h-0 group-hover:h-full ${!isOpen ? 'max-h-full': 'h-full'} w-full bottom-0 left-0 right-0`}>
        <div
          className={'flex flex-col h-full w-full items-center justify-center px-4 rounded-2xl overflow-hidden  bg-brandedColor-ORANGE'}>

          <div
            className={`w-full rounded-2xl transition-all duration-500 max-h-0 opacity-0  md:group-hover:max-h-max md:group-hover:opacity-100 ${showInfo ? 'max-h-full opacity-100' : ''}`}>
            <div className={'flex w-full gap-4'}>
              <div className={'flex flex-col gap-2 py-5'}>
                <div>
                <span className={'text-2xl text-black line-clamp-1'}>
                  {game.name}
                </span>
                </div>
              </div>
            </div>
            <div className={'w-full flex items-stretch gap-1 [&>*]:flex-1'}>
              <Badge label={t('labels.volatility')}
                     className={'bg-brandedColor-50 text-center font-normal [&>label]:text-black [&>label]:text-xs [&>label]:leading-[85%] px-0 py-4'}>
                <span
                  className={'inline-block font-Staatliches text-black font-bold text-sm leading-[95%] uppercase'}>{game.volatility}</span>
              </Badge>
              <Badge label={t('labels.rtp')}
                     className={'bg-brandedColor-50 text-center font-normal [&>label]:text-black [&>label]:text-xs [&>label]:leading-[85%] px-0 py-4'}>
                <span
                  className={'inline-block font-Staatliches text-black font-bold text-sm leading-[95%] uppercase'}>{game.rtp}</span>
              </Badge>
              <Badge label={t('labels.retention')}
                     className={'bg-brandedColor-50 text-center font-normal [&>label]:text-black [&>label]:text-xs [&>label]:leading-[85%] px-0 py-4'}>
                <span
                  className={'inline-block font-Staatliches text-black font-bold text-sm leading-[95%] uppercase'}>{game.retention ? game.retention : '??%'}</span>
              </Badge>
            </div>

            <div className={'w-full flex flex-col gap-2 my-2'}>
              <ButtonOutlined onClick={goToGamePage} className={'w-full text-black text-[15px] leading-[2]'}>
                {t('buttons.game_info')}
              </ButtonOutlined>
              <NavLink to={'/contacts'}
                       className={({ isActive }) => `flex w-full justify-center ${isActive ? '[&>span]:after:opacity-100' : '[&>span]:after:opacity-0'}`}>
            <span
              className={'flex justify-center w-full py-2.5  rounded-lg bg-brand-primary text-white text-base leading-[1.25] overflow-hidden '}>
              <span className={'relative z-[1]'}>
                {t('buttons.contacts')}
              </span>
            </span>
              </NavLink>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
})
